export let SettingMenuHistory = {
  name: 'exploration_history',
  title: 'Exploration history',
  shortcut: 'h'
}